import { useMemo, useState } from 'react';
import { PrintDataStructure, PrintItemDataEntity } from '../../../../../models/sift/json/print-model';
import './print-select-images.footer.scss';
import { Button } from '../../../../ui/button/button';
import { MdKeyboardDoubleArrowUp } from "react-icons/md";
import { MdKeyboardDoubleArrowDown } from "react-icons/md";
import { PrintSelectUseImageList } from './print-select-use-images';
import { PrintSelectImageData, ThumbImagesDataEntity } from '../hooks/use-print-select-images';

type Props = {
  structure: PrintDataStructure,
  selectOrder: PrintItemDataEntity | undefined,
  onComplete: (isOneTime?: boolean) => void,
  footerCollapseState: [boolean, React.Dispatch<React.SetStateAction<boolean>>],
  isInitializing: boolean,
  images: PrintSelectImageData[],
  onAllIncrement: () => void,
  onAllDecrement: () => void,
  onInputSelect: (id: string, count: number) => void,
  saveThumbImageList: ThumbImagesDataEntity[],
  loadImage: boolean,
}

export const PrintSelectImagesFooter = (props: Props) => {
  const {
    selectOrder,
    onComplete,
    footerCollapseState,
    structure,
    isInitializing,
    images,
    loadImage,
    saveThumbImageList,
    onAllIncrement,
    onAllDecrement,
    onInputSelect,
  } = props;
  const [open, setOpen] = footerCollapseState;
  const viewData = useMemo(() => {
    const borderType = selectOrder?.productData?.meta?.borderType ?? '';
    const borderList = selectOrder?.productData?.itemElements.find((v) => v.progFlg === 'edgeDtemp');
    const border = borderList?.list.find((v) => v.dataId === borderType)?.dataName ?? ''
    const paperType = selectOrder?.productData?.meta?.paperType ?? '';
    const paperList = selectOrder?.productData?.itemElements.find((v) => v.progFlg === 'paper');
    const paper = paperList?.list.find((v) => v.dataId === paperType)?.dataName ?? ''
    const laminateType = selectOrder?.productData?.meta?.laminateType ?? '';
    const laminateList = selectOrder?.productData?.itemElements.find((v) => v.progFlg === 'laminate');
    const laminate = laminateList?.list.find((v) => v.dataId === laminateType)?.dataName ?? ''
    const tapeList = selectOrder?.productData?.additional?.info1 ?? [];
    const tapeType = selectOrder?.productData?.meta?.additionalInfo ?? '';
    const matList = selectOrder?.productData?.additional?.info2 ?? [];
    const matType = selectOrder?.productData?.meta?.additionalInfo2 ?? '';
    const tape = tapeList.find((v) => v.additionalInfoId === tapeType)?.additionalInfoName ?? '';
    const mat = matList.find((v) => v.additionalInfo2Id === matType)?.additionalInfo2Name ?? '';

    return {
      item: selectOrder?.productData?.ProductDetailItemData?.itemName ?? '',
      paper,
      border,
      laminate,
      tape,
      mat,
    }
  }, [selectOrder]);

    const disabledComplete = useMemo(() => {
      return !isInitializing || !loadImage;
    }, [
      isInitializing,
      loadImage,
    ]);

    const disabledOneTimeSave = useMemo(() => {
      return !isInitializing;
    }, [
      isInitializing,
    ])

  return (
    <div className="print_select_images__footer">
      <div className="print_select_images__footer__image_list_wrap">
        <div className="print_select_images__footer__header">
          <div className="print_select_images__footer__header__title">
          プリントする画像一覧
          </div>
          <Button
            icon={open ?
              <MdKeyboardDoubleArrowDown size="17px" />
              : <MdKeyboardDoubleArrowUp size="17px" />
            }
            onClick={() => setOpen(!open)}
            className="print_select_images__footer__header__collapse_btn"
          />
        </div>
        <PrintSelectUseImageList
          list={images}
          open={open}
          saveThumbImageList={saveThumbImageList}
          onInputSelect={onInputSelect}
          onAllIncrement={onAllIncrement}
          onAllDecrement={onAllDecrement}
        />
      </div>
      <div className="print_select_images__footer__content">
        <div className="print_select_images__footer__item_info">
          <div>【商品名】{viewData.item}</div>
          <div>
            【ペーパー種】
            {viewData.paper}
            {viewData.laminate ? (
              <>&nbsp;【ラミネート種】{viewData.laminate}</>
            ) : ''}
            &nbsp;【フチ】{viewData.border}
            {viewData.tape ? (
              <>&nbsp;【テープ色】{viewData.tape}</>
            ) : ''}
            {viewData.mat ? (
              <>&nbsp;【マット】{viewData.mat}</>
            ) : ''}
            </div>
        </div>
        <div className="print_select_images__footer__right">
          <Button
            label="一時保存"
            color="secondary"
            className="print_select_images__footer__complete_button"
            onClick={() => onComplete(false)}
            disabled={disabledOneTimeSave}
          />
          <Button
            label="完了"
            className="print_select_images__footer__complete_button"
            onClick={() => onComplete(true)}
            disabled={disabledComplete}
          />
        </div>
      </div>
    </div>
  );
}
